import React from 'react';
import NoFound from 'assets/img/404.png';
import { PageMeta } from 'Elements';
import styles from 'partials/not-found.module.scss';

export const NotFound = () => {
	return (
		<div className={styles.page}>
			<PageMeta title="هیچ صفحه ای یافت نشد!" />
			<img src={NoFound} alt="404" className={styles.image} />
		</div>
	);
};
